import React, { useState, useEffect } from "react";

const CookieConsent = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        // Only run in the browser
        if (typeof window !== "undefined") {
            const consent = localStorage.getItem("cookieConsent");
            if (!consent) {
                setShowPopup(true);
            }
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookieConsent", "accepted");
        setShowPopup(false);
    };

    const handleReject = () => {
        localStorage.setItem("cookieConsent", "rejected");
        setShowPopup(false);
    };

    if (!showPopup) return null;

    return (
        <div style={styles.popup}>
            <p style={styles.text}>
                We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, personalize content, and serve targeted advertisements. By clicking "Accept Cookies," you consent to our use of cookies.
            </p>
            <button onClick={handleAccept} style={styles.button}>Accept</button>
            <button onClick={handleReject} style={{ ...styles.button, backgroundColor: "#d9534f" }}>Reject</button>
        </div>
    );
};

const styles = {
    popup: {
        position: "fixed",
        bottom: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "#fff",
        color: "#000",
        padding: "15px",
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 1000
    },
    text: {
        margin: 0,
        fontSize: "14px",
        maxWidth: "400px"
    },
    button: {
        padding: "8px 12px",
        backgroundColor: "#0c47d0",
        color: "#fff",
        border: "none",
        fontSize: "12px",
        cursor: "pointer",
        borderRadius: "5px",
    },
};

export default CookieConsent;
